/* istanbul ignore file */
import('./bootstrap');

// eslint workaround
export {};
